<template>
  <v-card>
    <v-card-title>
      <span
          class="text-h5"
          style="font-size: 18px !important; color: #333333; font-weight: 500"
      >{{isIeltsy ? 'Tạo bài test offline' :  'Tạo bài test online'}}</span
      >
    </v-card-title>
    <v-card-text>
      <v-container>
        <validation-observer ref="validator" v-slot="{ handleSubmit }">
          <v-row>
            <v-col cols="12" md="6" class="pa-0">
              <label
                  for=""
                  style="color: #000000; font-size: 16px; font-weight: normal"
              >Chọn con để tạo bài kiểm tra
                <span style="color: red">(*)</span>
              </label>
              <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="Chọn con"
              >
                <div>
                  <v-select
                      class="pt-0 mt-0"
                      :error-messages="errors"
                      :disabled="disableChild"
                      :items="contact.childCustomer"
                      item-text="fullName"
                      item-value="id"
                      v-model="selectChild"
                      ref="pickChild"
                      dense
                      placeholder="--Chọn con--"
                      outlined
                      no-data-text="Không có con"
                  ></v-select>
                </div>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-list dense height="92" class="pa-0" style="margin-top: 10px">
                <v-list-item
                    dense
                    class="body-2"
                    style="min-height: 28px; font-size: 16px !important; padding-bottom: 11px;padding-top: 22px"
                >
                  Phụ huynh :
                  <strong style="color: #4e4b66">{{
                      contact.contactFullName
                    }}</strong>
                </v-list-item>
                <v-list-item
                    dense
                    class="body-2"
                    style="min-height: 28px; font-size: 16px !important"
                >
                  Số điện thoại :
                  <strong style="color: #4e4b66"> {{ contact.mobile }}</strong>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col md="6" class="pa-0">
              <label
                  for=""
                  style="color: #000000; font-size: 16px; font-weight: normal"
              >Chọn thời gian lịch test
                <span style="color: red">(*)</span>
              </label>
              <div style="position: relative" id="pick-time-date">
                <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="Lịch test"
                >
                <v-text-field
                    type="datetime-local"
                    :error-messages="errors"
                    v-model="nullDatetime"
                    @input="checkTime"
                    ref="myDateTime"
                    />
                </validation-provider>
              </div>
            </v-col>
            <v-col class="pa-0" md="6">
              <v-list dense height="92" class="pa-0">
                <v-list-item
                    dense
                    class="body-2"
                    style="
                    min-height: 28px;
                    margin-top: 34px;
                    font-size: 16px !important;
                  "
                >
                  Ngày :
                  <strong style="color: #4e4b66">{{ pickTimeFilter }}</strong>
                </v-list-item>
                <v-list-item
                    style="font-size: 16px !important; font-weight: 400"
                >Giờ hẹn:
                  <strong style="color: #4e4b66">{{
                      pickHour
                    }}</strong></v-list-item
                >
              </v-list>
            </v-col>
            <v-col md="6" class="pa-0" v-if="isIeltsy">
              <label
                  for=""
                  style="color: #000000; font-size: 16px; font-weight: normal"
              >Chọn trường
                <span style="color: red">(*)</span>
              </label>
              <div style="position: relative" id="pick-time-date">
                <validation-provider
                    :error-messages="errors"
                    v-slot="{ errors }"
                    rules="required"
                    name="Chọn trường"
                >
                  <v-autocomplete
                      :error-messages="errors"
                      v-model="schoolId"
                      :items="schools"
                      item-text="school_name"
                      item-value="id"
                      placeholder="--Chọn trường--"
                      clearable
                  />
                </validation-provider>
              </div>
            </v-col>
            <v-col md="6" class="pa-0" v-if="isIeltsy"></v-col>
            <v-col cols="12" md="12" class="pa-0 pr-2 pt-2">
              <label
                for=""
                style="color: #000000; font-size: 16px; font-weight: normal"
              >Chọn chương trình
              </label>
              <v-autocomplete
                v-model="selectedCurriculum"
                :items="curricilumTest"
                item-text="name"
                item-value="id"
                return-object
                outlined
                dense
                :disabled="isDetail"
              >
              </v-autocomplete>
<!--              <div>-->
<!--                <v-tabs v-model="tab" vertical>-->
<!--                  <v-tab :disabled="isDetail" @change="selectCurriculum(curriculum)" class="vertical-tab" v-for="(curriculum, index) in curricilumTest" :key="index">{{curriculum.name}}</v-tab>-->
<!--                </v-tabs>-->
<!--              </div>-->


            </v-col>
            <v-col cols="12" md="12" class="pa-0">
              <div>
                <template>
                  <label
                    for=""
                    style="color: #000000; font-size: 16px; font-weight: normal"
                  >Chọn level
                  </label>
                  <v-select
                    v-model="ex5"
                    :items="curriculumOption"
                    item-text="text"
                    item-value="id"
                    outlined
                    :disabled="checkDisabled || isDetail"
                    dense
                    @change="checkMath"
                  >
                  </v-select>
                </template>
<!--                <div class="d-flex w-100" style="">-->
<!--                  <div v-for="math in curriculumOption" :key="math.id">-->
<!--                    <v-radio-group v-model="ex5" row>-->
<!--                      <v-radio-->
<!--                          color="blue"-->
<!--                          on-icon="mdi-circle-slice-8"-->
<!--                          off-icon="mdi-checkbox-blank-circle-outline"-->
<!--                          :label="math.text"-->
<!--                          :value="math.text"-->
<!--                          :disabled="checkDisabled"-->
<!--                          @change="checkMath(math)"-->
<!--                      ></v-radio>-->
<!--                    </v-radio-group>-->
<!--                  </div>-->
<!--                </div>-->
                <div>
                  <div class="d-flex align-center" v-if="isCoppy">
                    <a
                        v-if="objectSelect == 0 && myMathlink"
                        :href="myMathlink"
                        target="_blank"
                        rounded
                        class="display-1 width-100 text-truncate"
                        style="
                        border: 1px solid #2f80ed;
                        background: #f8fbff;
                        height: 48px;
                        width: 90%;
                        color: #2f80ed;
                        border-radius: 8px;
                        padding-left: 8px;
                        padding-top: 10px;
                      "
                    >{{ renderTextLink }}
                      {{ myMathlink }}
                      {{ myInput }}</a
                    >
                    <a
                        v-if="objectSelect == 1 && myEnglishlink"
                        :href="`${
                        renderTextLink ? renderTextLink : myEnglishlink
                      }`"
                        target="_blank"
                        rounded
                        class="display-1 width-100 text-truncate"
                        style="
                        border: 1px solid #2f80ed;
                        background: #f8fbff;
                        height: 48px;
                        width: 90%;
                        color: #2f80ed;
                        border-radius: 8px;
                        padding-left: 8px;
                        padding-top: 10px;
                      "
                    >{{ renderTextLink }} {{ myEnglishlink }}</a
                    >
                    <v-btn
                        icon
                        class="ml-4"
                        color="#2F80ED"
                        @click="coppyText"
                        style="background-color: white"
                    >
                      <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M15 1H4C2.9 1 2 1.9 2 3V16C2 16.55 2.45 17 3 17C3.55 17 4 16.55 4 16V4C4 3.45 4.45 3 5 3H15C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM15.59 5.59L20.42 10.42C20.79 10.79 21 11.3 21 11.83V21C21 22.1 20.1 23 19 23H7.99C6.89 23 6 22.1 6 21L6.01 7C6.01 5.9 6.9 5 8 5H14.17C14.7 5 15.21 5.21 15.59 5.59ZM15 12H19.5L14 6.5V11C14 11.55 14.45 12 15 12Z"
                            fill="#2F80ED"
                        />
                      </svg>
                    </v-btn>
                    <v-snackbar color="#3C88EE" v-model="snackbar">
                      Coppy link thành công!

                      <template v-slot:action="{ attrs }">
                        <v-btn
                            color="pink"
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                        >
                          Đóng
                        </v-btn>
                      </template>
                    </v-snackbar>
                  </div>
                  <v-btn
                      v-if="isCoppy == false && objectSelect == 0"
                      @click.prevent="
                      handleSubmit(createTutorLink);
                    "
                      :disabled="
                      !selectChild || !nullDatetime || errorTime || !curriculumId || !selectRadio
                    "
                      color="#2F80ED"
                  >
                    <v-icon class="mr-3">mdi-plus-circle</v-icon>

                    Tạo Link bài test</v-btn
                  >

                  <v-btn
                      v-if="isCoppy == false && objectSelect == 0 && butonTOAN_TAI_NANG"
                      @click.prevent="
                      handleSubmit(createTutorLink('toan_tai _nang'));
                    "
                      :disabled="
                      !selectChild || !nullDatetime || errorTime || !curriculumId || !selectRadio
                    "
                      color="primary"
                  >
                    <v-icon class="mr-3">mdi-plus-circle</v-icon>

                    Tạo Link bài test toán tài năng</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </validation-observer>
      </v-container>
    </v-card-text>
    <v-card-actions class="d-flex">
      <v-spacer></v-spacer>
      <v-btn color="#6E7191" text outlined rounded @click="closeTutorTest()">
        Đóng
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DatetimePicker from "vuetify-datetime-picker/src/components/DatetimePicker";
import moment from "moment";
import TutorTestRepository from "../../../repositories/TutorTestRepository";
import TestManageRepository from "../../../repositories/TestManageRepository";
import {
  IELTS,
  LEVEL_IELTS,
  IELTSY,
  curriculumTHPT,
  dhqghn,
  dhqgtphcm,
  dhbk,
  CT_TOAN_TAI_NANG, TA_SGK, TA_CAM, TOAN_DOU_CLC, curriculumTHPTAllGrade, KHTN,
} from "../../../helpers/constants";
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import { moduleSchoolLevel } from '@/helpers/constants';
import TokenService from "../../../helpers/token";
const SchoolRepository = RepositoryFactory.get('school');
const user = TokenService.getUser();
const dates = {
  Monday: "Thứ 2",
  Tuesday: "Thứ 3",
  Wednesday: "Thứ 4",
  Thursday: "Thứ 5",
  Friday: "Thứ 6",
  Saturday: "Thứ 7",
  Sunday: "Chủ nhật",
};

const isDev = process.env.VUE_APP_ENVIRONMENT == "dev";
const MAP_COURSE_ID = [
  {
    level: 1,
    courseId: 884,
  },
  {
    level: 2,
    courseId: 885,
  },
  {
    level: 3,
    courseId: 886,
  },
  {
    level: 4,
    courseId: 887,
  },
  {
    level: 5,
    courseId: 888,
  },
  // thay đổi theo môi trường
  { level: 6, courseId: isDev ? 474 : 1184 },
  { level: 7, courseId: isDev ? 475 : 1185 },
  { level: 8, courseId: isDev ? 476 : 1186 },
  { level: 9, courseId: isDev ? 477 : 1187 },
]
export default {
  props: ["contact","contacts","book","checkWaitStatus","contactDetail", "curriculums", "typeId", "isIeltsy", "schoolLevelId"],
  component: {},
  data() {
    return {
      selectedCurriculum: {},
      moduleSchoolLevel,
      dataStudyResult: {},
      dialogModal: false,
      isCoppy: false,
      snackbar: false,
      objectSelect: 0,
      selectChild: null,
      nullDatetime: (moment().add(1, 'day')).format('YYYY-MM-DDTHH:mm:ss'),
      contactTutors: [],
      contactsFilter: [],
      fullNameChild: [],
      listObjects: [],
      pickTimeTest: moment(this.nullDatetime,'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD HH:mm:ss'),
      pickTimeFilter: `${dates[moment(this.pickTimeTest).format('dddd')]}, ${moment(this.pickTimeTest).format('DD/MM/YYYY')}`,
      pickHour: moment(this.pickTimeTest).format('HH:mm') || "--/--",
      objectMath: null,
      checked: [],
      myInput: [],
      valid: true,
      subjectId: 1,
      ex5: false,
      englishRadio: false,
      snackbarTestLink: false,
      myMathlink: null,
      myEnglishlink: null,
      objectEnglish: null,
      grade: null,
      levelE: null,
      checkDisabled: false,
      checkDisabledEnglish: false,
      landscape: false,
      reactive: false,
      errorTime: false,
      hourPick: null,
      DatePick: null,
      listSubjects:null,
      disableChild:false,
      tab: null,
      curriculumOption: [],
      curriculumId: null,
      getMath: [
        {id : 1, text: "Lớp 1"},
        {id : 2, text: "Lớp 2"},
        {id : 3, text: "Lớp 3"},
        {id : 4, text: "Lớp 4"},
        {id : 5, text: "Lớp 5"},
        {id : 6, text: "Lớp 6"},
        {id : 7, text: "Lớp 7"},
      ],
      allGradeOption: [{id: 10, text: "Lớp 10"}, {id:11, text: 'Lớp 11'}, {id: 12, text: 'Lớp 12'}],
      selectRadio: false,
      levels: [{"text":"Level 0-1","id":1},{"text":"Level 2","id":2},{"text":"Level 3","id":3},{"text":"Level 4","id":4},{"text":"Level 5","id":5},{"text":"Level 6","id":6}],
      levelIeltsy: [{id: 20, text: "Kiddy (5 - 6 tuổi)"}, {id: 21, text: " Basic (6.5 - 8.5 tuổi)"}, {id: 22, text: "Advance (9 - 10.5 tuổi)"}],
      hasLevel: false,
      curricilumTest: [],
      checkNullCondition: false,
      schools: [],
      schoolId: null,
      IELTSY,
      curriculumTHPT,
      isDetail: false,
      CT_TOAN_TAI_NANG,
      butonTOAN_TAI_NANG: false,
      TA_SGK,
      TA_CAM,
      levelKHTN: [{id: 6, text: 'Lớp 6'}, {id: 7, text: 'Lớp 7'}, {id: 8, text: 'Lớp 8'}, {id: 9, text: 'Lớp 9'}],
      levelTASGK: [
        {id: 1, text: "Level 1 / lớp 1"},
        {id: 2, text: "Level 2 / lớp 2"},
        {id: 3, text: "Level 3 / lớp 3"},
        {id: 4, text: "Level 4 / lớp 4"},
        {id: 5, text: "Level 5 / lớp 5"},
        {id: 6, text: "Level 6 / lớp 6"},
        {id: 7, text: "Level 7 / lớp 7"},
        {id: 8, text: "Level 8 / lớp 8"},
        {id: 9, text: "Level 9 / lớp 9"},
      ],
      CT_KHTN_CC: +process.env.VUE_APP_CT_KHTN_CC,
    };
  },
  computed: {
    moduleschoolLevelId() {
      return this.$store.state.module.schoolLevelId
    }
  },
  async created() {
    // const getMath = await TutorTestRepository.getMath();
    const getListObjects = await TutorTestRepository.getListObject();
    this.listSubjects = getListObjects.data
    // this.getMath = getMath.data;
    this.listObjects = getListObjects.data.filter(
        (s) => s.alias == "tieng_anh"
    );
    this.filterCurriculum()
    Bus.$on('reset-value-test',()=>{
      this.checkDisabled = false;
      this.checkDisabledEnglish = false;
      this.disableChild = false;
      this.myEnglishlink = null;
      this.myMathlink = null;
      this.selectChild = null;
      this.isCoppy = false
    })
    if (this.isIeltsy) {
      this.getListSchool();
    }
  },
  methods: {
    checkTime() {
      if (
          moment(this.nullDatetime).format("YYYY-MM-DD HH:mm:ss") <
          moment().format("YYYY-MM-DD HH:mm:ss")
      ) {
        this.$swal({
          title: "Lỗi",
          text: "Bạn phải chọn thời gian lớn hơn hiện tại!",
          type: "warning",
        });
        this.errorTime = true;
        this.nullDatetime = null;
      } else {
        this.errorTime = false;
      }
      const label = document.querySelector(
          ".v-application--is-ltr .v-text-field .v-label"
      );

      label.style.display = "none";
      this.pickTimeTest = moment(this.nullDatetime,'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD HH:mm:ss')
      this.pickTimeFilter =
        `${
            this.nullDatetime ? dates[moment(this.pickTimeTest).format('dddd')] : '--'}, ${this.nullDatetime ? moment(this.pickTimeTest).format('DD/MM/YYYY') : '/--'}`;

      this.pickHour =this.nullDatetime ? moment(this.pickTimeTest).format('HH:mm') : '--/--';
    },
    async createTutorLink(value) {
      this.isCoppy = true;
      let contactTutor = {
        contactId: this.contact.id,
        customerId: this.selectChild,
        subjectId: this.subjectId,
        // gradeId: this.objectMath.grade_id,
        // level: this.objectEnglish.id,
        appointmentTime: this.pickTimeTest,
        curriculumId: this.curriculumId,
        isTHPT: false,
      };
      if (this.isIeltsy) {
        contactTutor['school_id'] = this.schoolId;
        contactTutor['type'] = 3;
      }
      if (this.curriculumId) {
        if (!this.checkNullCondition) {
          contactTutor.gradeId = this.objectMath.id;
        }
        if (this.hasLevel && !this.checkNullCondition) {
          contactTutor.level = this.objectMath.id;
          delete contactTutor.gradeId;
        }
        if ([this.CT_KHTN_CC, TA_SGK].includes(this.selectedCurriculum.id)) {
          contactTutor.courseId = _.get(MAP_COURSE_ID.find((e) => e.level === this.ex5), 'courseId', null);
          // Nếu là môn TA_SGK thuộc level 6789 => courseId = null
          if (this.selectedCurriculum.id == TA_SGK && [6,7,8,9].includes(this.ex5) ) {
            contactTutor.courseId = null;
          }
        }
        if (this.curriculumTHPT.includes(this.curriculumId)) {
          contactTutor["isTHPT"] = true;
        }
        if (value === 'toan_tai _nang') {
          contactTutor.level = 3;
        }
        if (this.curriculumId == TOAN_DOU_CLC) {
          contactTutor.level = 4;
        }
        if (this.selectedCurriculum.subject_id == KHTN) {
          contactTutor.level = 1;
        }
        let response
        if (this.curriculumId == IELTSY) {
          const payload = {
            ...contactTutor,
            create_user: user.id,
            create_user_name: `${user.lastName} ${user.firstName}`,
            school_id: this.schoolId,
            school_name: this.schools.find(s => s.id == this.schoolId)?.school_name,
            student_full_name: this.contact?.childCustomer.find(x => x.id == this.selectChild)?.fullName,
            student_mobile: this.contact?.mobile,
            curriculum_name: this.curriculums?.find(t => t.id == this.curriculumId)?.name,
            curriculum_section_id: 39,
            curriculum_section_title: "Demo Duet",
            customer_code: this.contact.code,
            type: 5
          }
          response = await TutorTestRepository.CreateStation(payload)
        }
        else if(this.$store.state.statusTutor){
          response = await TutorTestRepository.updateTest(this.book.id,contactTutor)
        }
        else if (!this.$store.state.statusTutor){
          response = await TutorTestRepository.CreateLinkTest(contactTutor);
        }
        let link_storage = "";
        if (response.status == 192) {
          let test_link = response.errors.testLink;
          if(test_link){
            this.myMathlink = test_link;
            link_storage = test_link;
          }
          else{
            this.isCoppy = false
          }
          //this.checkDisabled = true;
          this.$swal({
            title: 'Thông báo',
            type: "warring",
            html: `${response.message}`,
            showCancelButton: true,
            cancelButtonColor: '#ABABAB',
            confirmButtonColor: '#2173E5',
            cancelButtonText: 'Hủy',
            confirmButtonText: 'Xác nhận',
            reverseButtons: true,
          }).then(async (result) => {
            if (result.value) {
              const result = await TutorTestRepository.redoTest(
                {
                  testPracticeId: response.errors.testPracticeId,
                  formData: contactTutor,
                },
              )
              if (result.success) {
                this.$swal({
                  icon: 'success',
                  title: 'Thành công',
                  timer: '2000',
                })
                Bus.$emit('reload-interview')
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'Đã có lỗi xảy ra',
                  timer: '2000',
                })
              }
            }
          });
        }
        if (response.success) {
          let test_link = response.data.contactTutorPractice.testLink;
          this.myMathlink = test_link;
          this.grade = response.data.contactTutorPractice.grade;
          this.checkDisabled = true;
          link_storage = test_link;
          this.$swal({
            type: "success",
            text: "Tạo lịch test thành công",
          });
          Bus.$emit('reload-interview');
        }
        if (this.curriculumId == IELTSY && this.isIeltsy) {
          this.isCoppy = false;
          Bus.$emit('close-modal-test');
        }
        Bus.$emit("close-modal-test");
      }
    },
    checkMath(data) {
      this.objectMath = this.curriculumOption.find((e) => e.id === data);
      this.selectRadio = true;
      this.isCoppy = false;
      if (this.curriculumId == CT_TOAN_TAI_NANG) {
        // Các lớp hiển thị nút "Tạo link bài test toán toàn năng"
        this.butonTOAN_TAI_NANG = [4,5,6,7,8,9].includes(+data);
      }

    },
    checkEnglish(data) {
      this.objectEnglish = data.id;
    },
    coppyText() {
      this.snackbar = true;
      if (this.objectEnglish) {
        navigator.clipboard.writeText(this.myEnglishlink);
      } else {
        navigator.clipboard.writeText(this.myMathlink);
      }
    },
    closeTutorTest() {
      this.checkWaitStatus = false
      this.$store.commit('CHECK_STATUS_QUICKVIEW',this.checkWaitStatus)
      Bus.$emit("close-modal-test");
      if (!this.book){
        localStorage.removeItem("local_storage_tutor");
        this.$refs.myDateTime.date = ''
        this.$refs.myDateTime.time = ''
        this.$refs.pickChild.resetValidation()
        this.nullDatetime = null;
        this.selectChild = null;
        this.dialogModal = false;
        this.pickTimeFilter = null;
        this.pickTimeFilter = "--/--";
        this.pickHour = "--/--";
        this.englishRadio = null;
        this.ex5 = null;
        this.myMathlink = null
        this.isCoppy = false
      }
    },
    selectCurriculum(curriculum) {
      this.selectedCurriculum = curriculum;
      this.butonTOAN_TAI_NANG = false;
      this.hasLevel = false;
      this.curriculumOption = [];
      this.checkNullCondition = false;
      this.selectRadio = false;
      this.ex5 = '';
      const checkGrade = curriculum.test_type.find(item => item.arrange_condition == "grade_id");
      const checkLevel = curriculum.test_type.find(item => item.arrange_condition == "level");
      this.subjectId = curriculum.subject_id;
      if (curriculum.id == IELTS && checkLevel && !checkGrade) {
        this.curriculumOption = LEVEL_IELTS;
        this.hasLevel = true;
      }
      else if (curriculum.id == IELTSY && checkLevel && !checkGrade && this.isIeltsy) {
        this.curriculumOption = this.levelIeltsy;
        this.hasLevel = true
      }
      else if (curriculum.subject_id == KHTN && this.typeId == 2 && this.schoolLevelId == moduleSchoolLevel.THCS) {
        this.curriculumOption = this.levelKHTN;
      }
      else if (curriculumTHPTAllGrade.includes(curriculum.id)) {
        this.curriculumOption = this.allGradeOption;
      }
      else if (curriculumTHPT.includes(curriculum.id)) {
        this.curriculumOption = [{id: 12, text: "Lớp 12"}];
      }
      else if (curriculum.id == this.TA_SGK) {
        this.curriculumOption = this.levelTASGK;
        this.hasLevel = true
      }
      else if (checkGrade) {
        this.curriculumOption = this.getMath;
        if (curriculum.id == CT_TOAN_TAI_NANG || curriculum.id == TOAN_DOU_CLC) {
          this.curriculumOption = [
            ...this.getMath, 
            {id:8, text: 'Lớp 8'},
            {id:9, text: 'Lớp 9'},
            {id:10, text: 'Lớp 10'},
            {id:11, text: 'Lớp 11'},
            {id:12, text: 'Lớp 12'}
          ];
        }
      }
      else if (!checkGrade && checkLevel) {
        this.curriculumOption = this.levels;
        this.hasLevel = true;
      }
      this.curriculumId = curriculum.id;
      this.checkDisabled = false;
      this.isCoppy = false;
      this.checkNullCondition = curriculum.test_type.every(item => !item.arrange_condition)
      if (this.checkNullCondition) {
        this.selectRadio = true
      }
    },
    filterCurriculum() {
      this.checkNullCondition = false;
      if (this.isIeltsy) {
        for (const curriculum of this.curriculums) {
          for (const item of curriculum.test_type) {
            if (item.type_placement_test == "link_test_ieltsy") {
              this.curricilumTest.push(curriculum)
            }
          }
        }
      } else {
        for (const curriculum of this.curriculums) {
          for (const item of curriculum.test_type) {
            if (item.type_placement_test == "link_test") {
              this.curricilumTest.push(curriculum)
            }
          }
        }
      }
      this.curricilumTest = _.uniqBy(this.curricilumTest, 'id')
      console.log("this.typeId == 1 && this.schoolLevelId == 2:", this.typeId == 1 && this.schoolLevelId == 2)
      if (this.typeId == 1 && this.schoolLevelId == 2) {
        this.curricilumTest = this.curricilumTest.filter(s => s.type_school_level_id.includes(2));
      }
      const firstCurriculum = this.curricilumTest[0];
      this.curriculumId = firstCurriculum?.id;
      const checkGrade = firstCurriculum?.test_type.find(item => item.arrange_condition == "grade_id");
      const checkLevel = firstCurriculum?.test_type.find(item => item.arrange_condition == "level");

      this.subjectId = firstCurriculum?.subject_id;
      if (!this.book && firstCurriculum) {
        if (firstCurriculum.id == IELTS && !checkGrade && checkLevel) {
          this.curriculumOption = LEVEL_IELTS;
          this.hasLevel = true
        }
        else if (firstCurriculum.id == IELTSY && checkLevel && !checkGrade && this.isIeltsy) {
          this.curriculumOption = this.levelIeltsy;
          this.hasLevel = true
        }
        else if (firstCurriculum.id == this.TA_SGK) {
          this.curriculumOption = this.levelTASGK;
        }
        else if (firstCurriculum.subject_id == KHTN && this.typeId == 2 && this.schoolLevelId == moduleSchoolLevel.THCS) {
          this.curriculumOption = this.levelKHTN;
        }
        else if (checkGrade) {
          this.curriculumOption = this.getMath
          if (firstCurriculum.id == CT_TOAN_TAI_NANG || firstCurriculum.id == TOAN_DOU_CLC) {
            this.curriculumOption = [
              ...this.getMath, 
              {id: 8, text: "Lớp 8"},
              {id:9, text: 'Lớp 9'},
              {id:10, text: 'Lớp 10'},
              {id:11, text: 'Lớp 11'},
              {id:12, text: 'Lớp 12'},
            ]
          }
        }
        else if (!checkGrade && checkLevel) {
          this.curriculumOption = this.levels;
          this.hasLevel = true
        }
      }
      this.checkNullCondition = firstCurriculum?.test_type.every(item => !item.arrange_condition)
      this.checkNullCondition && (this.selectRadio = true);
    },
    async getListSchool() {
      let attrs = '&attrs[]=id&attrs[]=school_name&filters[$eq__status]=1'
      if([this.moduleSchoolLevel.STATION,this.moduleSchoolLevel.SCHOOL].includes(this.moduleschoolLevelId)) {
         attrs += this.moduleschoolLevelId === this.moduleSchoolLevel.STATION ? '&filters[$eq__type]=station' : '&filters[$eq__type]=school'
      }
      const response = await SchoolRepository.listSchoolApi(attrs);
      this.schools = _.get(response, 'data');
    }
  },
  watch:{
    selectedCurriculum: {
      handler(curriculum, oldCurriculum) {
        this.butonTOAN_TAI_NANG = false;
        this.hasLevel = false;
        this.curriculumOption = [];
        this.checkNullCondition = false;
        this.selectRadio = false;
        if (!_.isEmpty(oldCurriculum)) {
          this.ex5 = null;
        }
        const checkGrade = _.get(curriculum, 'test_type', []).find(item => item.arrange_condition == "grade_id");
        const checkLevel = _.get(curriculum, 'test_type', []).find(item => item.arrange_condition == "level");

        this.subjectId = curriculum.subject_id;


        if (curriculum?.id == IELTS && !checkGrade && checkLevel) {
          this.curriculumOption = LEVEL_IELTS;
          this.hasLevel = true
        }
        else if (curriculum.id == IELTSY && checkLevel && !checkGrade && this.isIeltsy) {
          this.curriculumOption = this.levelIeltsy;
          this.hasLevel = true
        }
        else if (curriculum.subject_id == KHTN && this.typeId == 2 && this.schoolLevelId == moduleSchoolLevel.THCS) {
          this.curriculumOption = this.levelKHTN;
        }
        else if (curriculumTHPTAllGrade.includes(curriculum.id)) {
          this.curriculumOption = this.allGradeOption;
        }
        else if (curriculumTHPT.includes(curriculum.id)) {
          this.curriculumOption = [{id: 12, text: "Lớp 12"}];
        }
        else if (curriculum.id == TA_SGK) {
          this.curriculumOption = this.levelTASGK;
          this.hasLevel = true;
        }
        else if (checkGrade) {
          this.curriculumOption = this.getMath
          if (curriculum.id == CT_TOAN_TAI_NANG || curriculum.id == TOAN_DOU_CLC) {
            this.curriculumOption = [
              ...this.getMath, 
              {id: 8, text: "Lớp 8"},
              {id:9, text: 'Lớp 9'},
              {id:10, text: 'Lớp 10'},
              {id:11, text: 'Lớp 11'},
              {id:12, text: 'Lớp 12'},
            ]
          }
        }
        else if (!checkGrade && checkLevel) {
          this.curriculumOption = this.levels;
          this.hasLevel = true
        }
        this.curriculumId = curriculum.id;
        this.checkDisabled = false;
        if (!_.isEmpty(oldCurriculum)) {
          this.isCoppy = false;
        }
        this.checkNullCondition = _.get(curriculum, 'test_type', []).every(item => !item.arrange_condition)
        if (this.checkNullCondition) {
          this.selectRadio = true
        }
      },
      deep: true,
    },
    book:{
      handler:function (newVal, oldVal) {
        if(newVal){
          this.isDetail = true;
          this.selectChild = newVal.customerId
          if(newVal.status.value == 0){
            this.disableChild = true
          }
          else{
            this.disableChild = false
          }
          if(newVal.interviewDateAt.length > 0){
            this.nullDatetime = moment(`${newVal.interviewDateAt} ${newVal.fromTime}`,'DD/MM/YYYY hh:mm').format('YYYY-MM-DD HH:mm')
            this.pickTimeFilter = newVal.interviewDateAt
            this.pickHour = newVal.fromTime
          }
          if (newVal.testLink) {
            this.isCoppy = true
            this.checkDisabled = true
            this.checkDisabledEnglish = true
            if (newVal.subjectId == 3) {
              this.myEnglishlink = newVal.testLink
            } else {
              this.myMathlink = newVal.testLink
            }
          }
          if(newVal.subjectId == 3){
            this.objectSelect = 1
            this.objectEnglish = 1
          }
          if(newVal.subjectId == 1 || newVal.subjectId === 10){
            this.objectSelect = 0
            this.objectMath = 1
          }
          if (newVal.level) {
            this.ex5 = this.levels.find(item => item.id == newVal.level)?.id;
          }
          if (newVal.schoolId) {
            this.schoolId = newVal.schoolId;
          }
          if (newVal.curriculumId) {
            if (newVal.curriculumId == IELTS) {
              this.ex5 = LEVEL_IELTS.find(item => item.id == newVal.level)?.id;
            }
            if (newVal.curriculumId == IELTSY && this.isIeltsy) {
              this.ex5 = this.levelIeltsy.find(item => item.id == newVal.level)?.id;
              this.isCoppy = false;
            }
            if (curriculumTHPT.includes(newVal.curriculumId)) {
              this.ex5 = "Lớp 12";
            }
            if (curriculumTHPTAllGrade.includes(newVal.curriculumId)) {
              this.ex5 = this.allGradeOption.find(item => item.id == newVal.gradeId)?.id;
            }
            if (newVal.curriculumId == this.TA_SGK) {
              this.ex5 = this.levelTASGK.find(item => item.id == newVal.level)?.id;
            }
            let curriculums = []
            if (this.isIeltsy) {
              this.getListSchool();
              for (const curriculum of this.curriculums) {
                for (const item of curriculum.test_type) {
                  if (item.type_placement_test == "link_test_ieltsy") {
                    curriculums.push(curriculum)
                  }
                }
              }
            } else {
              for (const curriculum of this.curriculums) {
                for (const item of curriculum.test_type) {
                  if (item.type_placement_test == "link_test") {
                    curriculums.push(curriculum)
                  }
                }
              }
            }
            if (this.typeId == 1 && this.schoolLevelId == 2) {
              curriculums = curriculums.filter(s => s.type_school_level_id.includes(2))
            }

            curriculums = _.uniqBy(curriculums, 'id')
            this.selectedCurriculum = curriculums.find(item => item.id == newVal.curriculumId)
            const checkGrade = _.get(this.selectedCurriculum, 'test_type', []).find(item => item.arrange_condition == "grade_id");
            const checkLevel = _.get(this.selectedCurriculum, 'test_type', []).find(item => item.arrange_condition == "level");
            if (this.selectedCurriculum?.id == IELTS && !checkGrade && checkLevel) {
              this.curriculumOption = LEVEL_IELTS;
              this.hasLevel = true
            }
            else if (this.selectedCurriculum.id == IELTSY && checkLevel && !checkGrade && this.isIeltsy) {
              this.curriculumOption = this.levelIeltsy;
              this.hasLevel = true
            }
            else if (this.selectedCurriculum.subject_id == KHTN && this.typeId == 2 && this.schoolLevelId == moduleSchoolLevel.THCS) {
              this.curriculumOption = this.levelKHTN;
            }
            else if (curriculumTHPTAllGrade.includes(this.selectedCurriculum.id)) {
              this.curriculumOption = this.allGradeOption;
            }
            else if (curriculumTHPT.includes(this.selectedCurriculum.id)) {
              this.curriculumOption = [{id: 12, text: "Lớp 12"}];
            }
            else if (this.selectedCurriculum.id == TA_SGK) {
              this.curriculumOption = this.levelTASGK;
            }
            else if (checkGrade) {
              this.curriculumOption = this.getMath
              if (this.selectedCurriculum.id == CT_TOAN_TAI_NANG || this.selectedCurriculum.id == TOAN_DOU_CLC) {
                this.curriculumOption = [
                  ...this.getMath, 
                  {id: 8, text: "Lớp 8"},
                  {id:9, text: 'Lớp 9'},
                  {id:10, text: 'Lớp 10'},
                  {id:11, text: 'Lớp 11'},
                  {id:12, text: 'Lớp 12'}
                ]
              }
            }
            else if (!checkGrade && checkLevel) {
              this.curriculumOption = this.levels;
              this.hasLevel = true
            }
          }
          if (newVal.gradeId) {
            this.ex5 = this.curriculumOption.find(item => item.id == newVal.gradeId)?.id;
            // if (newVal.gradeId == 8) {
            //   this.ex5 = "Lớp 8";
            // } else if (newVal.gradeId === 9) {
            //   this.ex5 = "Lớp 9";
            // }
          }
        }
        else {
          this.isDetail = false;
          this.pickTimeTest = null
          localStorage.removeItem("local_storage_tutor");
          this.nullDatetime = (moment().add(1, 'day')).format('YYYY-MM-DDTHH:mm:ss');
          this.selectChild = null;
          this.dialogModal = false;
          this.pickTimeTest = moment(this.nullDatetime,'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD HH:mm:ss');
          this.pickTimeFilter = moment(this.nullDatetime,'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD HH:mm:ss');
          this.pickHour = moment(this.pickTimeTest).format('HH:mm') || "--/--";
          this.englishRadio = null;
          this.ex5 = null;
          this.myMathlink = null
          this.isCoppy = false;
          this.schoolId = null;
        }
      },
      immediate: true,
    }
  }
};
</script>
<style lang="scss" scoped>
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: unset;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background: #94bdf6 !important;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 8px !important;
}

.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}

::v-deep .link-test-active {
  border: 1px solid #2f80ed;
  background: #f8fbff;
  height: 48px;
  width: 90%;
  color: #2f80ed;
  border-radius: 8px;
  padding-left: 8px;
  padding-top: 10px;
}

.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}

.ch-tag-trial {
  color: #f2994a;
  border: 1px solid #f2994a;
}

.v-tag-trial {
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
}
</style>
<style lang="scss">
#pick-time-date .v-input .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
}
.v-tabs--vertical {
  align-items: start;
  flex-direction: column;
}
.v-tabs.v-tabs--vertical.theme--light {
  width: 177px;
}
//.v-tabs-slider-wrapper {
//  left: auto !important;
//  right: 0;
//}
.vertical-tab.v-tab {
  justify-content: start!important;
  text-transform: capitalize!important;
  white-space: pre-wrap!important;
  width: 175px!important;
  text-align: left!important;
  white-space: pre-wrap!important;
}
</style>
